import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorKey = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M15.88 1.25h5.87v6.5h-1.92v2h-1.92v2h-2.198l-.003.005a7.25 7.25 0 1 1-6.557-3.497L15.88 1.25Zm.64 1.5-6.72 7h-.318a5.75 5.75 0 1 0 4.752 2.486l-.247-.358.781-1.628h1.642v-2h1.92v-2h1.92v-3.5h-3.73Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      d="M9.347 13.506a2 2 0 1 0 .306 3.989 2 2 0 0 0-.306-3.99Z"
    />
  </svg>
);
export default SvgTwoColorKey;
